import { Entity } from "@models/Entity";
import { mapPostgresError } from "./mapPostgresError";
import { featureErrorMappers } from "./registry";
import { POSTGRES_CODES } from "./postgresCodes";
import type { Action } from "./types";

const ENTITY_LABEL: Record<Entity, string> = {
  [Entity.PRODUCTS]: "product",
  [Entity.LOCATIONS]: "location",
  [Entity.STOCK]: "stock",
  [Entity.ORDERS]: "order",
  [Entity.CUSTOMERS]: "customer",
  [Entity.SUPPLIERS]: "supplier",
  [Entity.PURCHASE_ORDERS]: "purchase order",
  [Entity.TAGS]: "tag",
  [Entity.BILLING]: "subscription",
  [Entity.IMAGES]: "image",
};

const ACTION_VERB: Record<Action, string> = {
  create: "create",
  update: "update",
  delete: "delete",
  save: "save",
  import: "import",
  checkout: "start checkout for",
  manage: "open billing for",
  fetch: "load",
};

export function messageFor(
  entity: Entity,
  action: Action,
  rawError: unknown
): string {
  const mapped = mapPostgresError(rawError);

  const featureMessage = featureErrorMappers[entity]?.(action, mapped);
  if (featureMessage) return featureMessage;

  if (mapped.code === POSTGRES_CODES.INSUFFICIENT_PRIVILEGE) {
    return `You don't have permission to ${ACTION_VERB[action]} this ${ENTITY_LABEL[entity]}.`;
  }

  return `Failed to ${ACTION_VERB[action]} ${ENTITY_LABEL[entity]}.`;
}

export function errorScope(entity: Entity, action: Action): string {
  return `${entity}.${action}`;
}
